import { FC, SVGProps } from 'react'

export const AuthorsIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 11.6272C10.9972 11.6272 10.0354 11.2288 9.32634 10.5197C8.61724 9.81063 8.21887 8.84888 8.21887 7.84607C8.21887 6.84325 8.61724 5.88151 9.32634 5.17241C10.0354 4.46331 10.9972 4.06494 12 4.06494C13.0028 4.06494 13.9646 4.46331 14.6737 5.17241C15.3828 5.88151 15.7811 6.84325 15.7811 7.84607C15.7811 8.84888 15.3828 9.81063 14.6737 10.5197C13.9646 11.2288 13.0028 11.6272 12 11.6272ZM12 13.2884C17.0273 13.2884 20.25 16.0627 20.25 17.4134V19.9357H3.75V17.4134C3.75 15.7799 6.801 13.2884 12 13.2884Z"
        fill="black"
      />
    </svg>
  )
}
